import { forEach } from 'lodash';
import { UNIQUE_ATTRIBUTES } from './constants';

export const calculateHeight = (ref) => {
    const clonedContainer = ref.current.cloneNode(true);

    removeUniqueAttributes(clonedContainer);
    clonedContainer.style.height = 'auto';

    const { parentNode } = ref.current;
    parentNode.appendChild(clonedContainer);
    const { scrollHeight } = clonedContainer;
    parentNode.removeChild(clonedContainer);

    return scrollHeight;
};

const removeUniqueAttributes = (element: Element) => {
    UNIQUE_ATTRIBUTES.forEach((attribute) => element.removeAttribute(attribute));

    forEach(element.children, removeUniqueAttributes);
};
